/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Payment_Method_Change_UnsupportedInputs */

const vi_error_payment_method_change_unsupported = /** @type {(inputs: Error_Payment_Method_Change_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ đổi được giữa Tiền mặt và Chuyển khoản. Khoản này ghi bằng hình thức khác.`)
};

/**

* @param {Error_Payment_Method_Change_UnsupportedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_payment_method_change_unsupported = /** @type {((inputs?: Error_Payment_Method_Change_UnsupportedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Payment_Method_Change_UnsupportedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_payment_method_change_unsupported(inputs)
});